import { TFunction } from 'i18next';
import { Coupon } from '../../../../../types/coupon';

type CouponFormData = Omit<Coupon, 'id' | 'used_count'>;

interface ValidationResult {
  isValid: boolean;
  errors: Record<string, string>;
}

export const validateCouponForm = (
  formData: CouponFormData,
  emptyInputs: Record<string, boolean>,
  t: TFunction
): ValidationResult => {
  const errors: Record<string, string> = {};

  // Validate required fields
  if (!formData.code.trim()) {
    errors.code = t('Coupon code is required');
  }

  // Check if discount value is required
  if (emptyInputs.discount_value || formData.discount_value <= 0) {
    errors.discount_value = t('Discount value must be greater than 0');
  }

  if (formData.discount_type === 'percentage' && formData.discount_value > 100) {
    errors.discount_value = t('Percentage discount cannot exceed 100%');
  }

  if (formData.min_cart_total < 0) {
    errors.min_cart_total = t('Minimum cart total cannot be negative');
  }

  if (!formData.start_date) {
    errors.start_date = t('Start date is required');
  }

  if (!formData.end_date) {
    errors.end_date = t('End date is required');
  }

  if (
    formData.start_date &&
    formData.end_date &&
    new Date(formData.start_date) > new Date(formData.end_date)
  ) {
    errors.end_date = t('End date must be after start date');
  }

  if (formData.usage_limit <= 0) {
    errors.usage_limit = t('Usage limit must be greater than 0');
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};